import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/calendar_entry';

export default {
  getConfig() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/get_config',
    })
      .then((response: any) => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  },

  fetchEvents(params: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint,
        params,
      })
        .then((response: any) => {
          if (response && response.data.success) {
            console.log(response.data.data);
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  fetchEventById(eventId: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + eventId,
      })
        .then((response: any) => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getSelfAttendance(eventid: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + eventid + '/attendance',
      })
        .then((response: any) => {
          if (response && response.data.success) {
            resolve(response.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  setSelfAttendance(eventid: number, attendanceObj: object) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + '/' + eventid + '/attendance',
        data: attendanceObj,
      })
        .then((response: any) => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  setVerifyToken(token: string, eventid: number, attendanceid: number) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + eventid + '/attendance/' + attendanceid + '/verify',
      params: { token: token },
    })
      .then((response: any) => {
        if (response) {
          return response;
        } else {
          console.log('error');
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  },
};
